/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	window.CursorParallax = __webpack_require__(1);

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CursorParallax = function () {
	  function CursorParallax(wrapper, options) {
	    _classCallCheck(this, CursorParallax);
	
	    this.isStop = true;
	
	    this.options = this.supplement({
	      easing: 'ease-out',
	      duration: '.6s',
	      mousemoveRatio: 0.5,
	      deviceorientationRatio: 1,
	      mousemove: true,
	      deviceorientation: true
	    }, options);
	
	    this.initElements(wrapper);
	
	    this.setEvents();
	
	    this.start();
	  }
	
	  _createClass(CursorParallax, [{
	    key: 'initElements',
	    value: function initElements(wrapper) {
	      var _this = this;
	
	      this.elm_wrapper = typeof wrapper === 'string' ? document.querySelector(wrapper) : wrapper;
	      this.elm_layers = this.elm_wrapper.querySelectorAll('.layer');
	      this.elm_wrapper.style.position = 'relative';
	      this.elm_wrapper.style.backfaceVisibility = 'hidden';
	      this.elm_wrapper.style.transform = 'translate3d(0px, 0px, 0px)';
	      this.elm_wrapper.style.transformStyle = 'preserve-3d';
	      this.elm_layers.forEach(function (elm_layer) {
	        elm_layer.style.position = 'absolute';
	        elm_layer.style.top = 0;
	        elm_layer.style.left = 0;
	        elm_layer.style.width = '100%';
	        elm_layer.style.height = '100%';
	        elm_layer.style.transition = 'transform 0.6s ease-out';
	        elm_layer.style.transitionProperty = 'transform';
	        elm_layer.style.transitionDuration = _this.options.duration;
	        elm_layer.style.transitionTimingFunction = _this.options.easing;
	        elm_layer._depth = parseFloat(elm_layer.getAttribute('data-depth'));
	      });
	
	      var rect = this.elm_wrapper.getBoundingClientRect();
	      this.elm_wrapper._offset = {};
	      this.elm_wrapper._offset.top = rect.top + window.pageYOffset;
	      this.elm_wrapper._offset.left = rect.left + window.pageXOffset;
	      this.elm_wrapper._offset.width = this.elm_wrapper.offsetWidth;
	      this.elm_wrapper._offset.height = this.elm_wrapper.offsetHeight;
	    }
	  }, {
	    key: 'setEvents',
	    value: function setEvents() {
	      if (this.options.mousemove) {
	        this.elm_wrapper.addEventListener('mousemove', this.mousemove.bind(this));
	      }
	      if (this.options.deviceorientation) {
	        window.addEventListener('deviceorientation', this.deviceorientation.bind(this));
	      }
	    }
	  }, {
	    key: 'removeEvents',
	    value: function removeEvents() {
	      this.elm_wrapper.removeEventListener('mousemove', this.mousemove);
	      window.removeEventListener('deviceorientation', this.deviceorientation);
	    }
	  }, {
	    key: 'moveLayer',
	    value: function moveLayer(x, y) {
	      if (this.isStop) return;
	      this.elm_layers.forEach(function (elm_layer) {
	        var _x = x * elm_layer._depth;
	        var _y = y * elm_layer._depth;
	        elm_layer.style.transform = 'translate3d(' + _x + '%, ' + _y + '%, 0)';
	      });
	    }
	  }, {
	    key: 'mousemove',
	    value: function mousemove(e) {
	      var my = e.pageY - this.elm_wrapper._offset.top;
	      var mx = e.pageX - this.elm_wrapper._offset.left;
	      var x = Math.round(mx / this.elm_wrapper._offset.width * 100) - 50;
	      var y = Math.round(my / this.elm_wrapper._offset.height * 100) - 50;
	      x = x * this.options.mousemoveRatio;
	      y = y * this.options.mousemoveRatio;
	      this.moveLayer(x, y);
	    }
	  }, {
	    key: 'deviceorientation',
	    value: function deviceorientation(e) {
	      var x = (Math.round(e.gamma) / 2 + 45) / 90 * 100 - 50;
	      var y = (Math.round(e.beta) / 2 + 45) / 90 * 100 - 50;
	      x = x * this.options.deviceorientationRatio;
	      y = y * this.options.deviceorientationRatio;
	      this.moveLayer(x, y);
	    }
	  }, {
	    key: 'supplement',
	    value: function supplement(defaultOptions, options) {
	      var _options = {};
	      Object.keys(defaultOptions).forEach(function (key) {
	        _options[key] = options[key] === undefined ? defaultOptions[key] : options[key];
	      });
	      return _options;
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.isStop = true;
	    }
	  }, {
	    key: 'start',
	    value: function start() {
	      this.isStop = false;
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      removeEvents();
	    }
	  }]);
	
	  return CursorParallax;
	}();
	
	module.exports = CursorParallax;

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// cursor-parallax.js